import React from "react";
import "./Button3D.css";

interface ButtonProps {
  buttonText?: string;
  buttonIcon?: React.ReactNode;
  onClick?: () => void;
  type?: "submit" | "reset" | "button" | undefined;
}

const Button3D: React.FC<ButtonProps> = ({
  buttonText,
  buttonIcon,
  onClick,
  type,
}) => {
  return (
    <>
      <button type={type} onClick={onClick}>
        <span className="shadow"></span>
        <span className="edge"></span>
        <div className="front" style={{ fontFamily: "Nunito",display:"flex",justifyContent:"center",height:"auto",alignItems:"center" }}>
          <span>{buttonIcon}</span>
          <span>{buttonText}</span>
        </div>
      </button>
    </>
  );
};

export default Button3D;
